// extracted by mini-css-extract-plugin
export default {"avatar":"G5X0fB","withBorder":"uXpHPL","filter":"wtTTRi"};